import React from "react";

import { Box, Typography, Grid, Container } from "@material-ui/core";

import SwitchFields from "../../../hook/SwitchFields";
import MaskUtils from "../../../utils/maskUtils";
import fixedData from "./fixedData";

import useStyles from "./style";

export default function FormPesquisaCreditoPart2(props) {
    const classes = useStyles();
    const document = () =>
        props.modelos.find((e) => e.id == props.relatorios).tipo_documento;
    return (
        <div>
            <Typography component="div">
                <Box
                    fontSize={20}
                    textAlign={!props.mediaquery ? "center" : "start"}
                    fontWeight="fontWeightRegular"
                >
                    Em seguida, defina os parâmetros da sua pesquisa
                </Box>
            </Typography>
            <Box my={4}>
                <div>
                    <Grid
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        {props.relatorios ? (
                            SwitchFields(
                                fixedData.document(document(), MaskUtils),
                                {
                                    mediaquery: props.mediaquery,
                                }
                            )
                        ) : (
                            <div className={classes.objDescriptionclass}>
                                Selecione um tipo de consulta.
                            </div>
                        )}

                        {props.modelos.map((e) => {
                            if (
                                e.id == props.relatorios &&
                                e.parametros_portal
                            ) {
                                return e.parametros_portal.fields.map(
                                    (e, i) => {
                                        return (
                                            <div
                                                key={i}
                                                style={{
                                                    width: !props.mediaquery
                                                        ? "100%"
                                                        : "auto",
                                                }}
                                            >
                                                {SwitchFields(e, {
                                                    mediaquery:
                                                        props.mediaquery,
                                                })}
                                            </div>
                                        );
                                    }
                                );
                            }
                        })}
                    </Grid>
                </div>
            </Box>
        </div>
    );
}
